import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

// Components
import ColorRange from '../ColorRange/ColorRange';

// Store
import {
  $colorRangeIndexSelected,
  $colorRangeSteps,
  setColorRangeIndexSelected,
  setColorRangeSelected,
} from '../../store/slices/sidebarMapFiltersSlice';

// Configs
import { COLOR_RANGES } from '../../configs/mapColor.configs';

// Styles
import './ColorBreaksDropdown.scss';

const SELECT_TITLE = 'Color Breaks';

function ColorBreaksDropdown() {
  const dispatch = useDispatch();
  const colorRangeSteps = useSelector($colorRangeSteps);
  const colorRangeIndexSelected = useSelector($colorRangeIndexSelected);

  const handleColorBreaksDropdown = (event: any) => {
    const { value } = event.target;
    dispatch(setColorRangeIndexSelected(value));
    dispatch(setColorRangeSelected(COLOR_RANGES[value].slice(0, colorRangeSteps)));
  };

  return (
    <div className={'ColorBreaksDropdown__container'}>
      <FormControl fullWidth className={'ColorBreaksDropdown'}>
        <InputLabel id='demo-simple-select-label'>{SELECT_TITLE}</InputLabel>
        <Select
          id={'color-breaks-dropdown'}
          label={SELECT_TITLE}
          labelId={'color-breaks-dropdown-label'}
          value={colorRangeIndexSelected}
          onChange={handleColorBreaksDropdown}
        >
          {COLOR_RANGES.map((colorRange: any, index: number) => {
            return (
              <MenuItem key={index} value={index}>
                <ColorRange set={index} colorRange={colorRange} colorRangeSteps={colorRangeSteps} />
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </div>
  );
}

export default ColorBreaksDropdown;
